import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

productListLineStyles.editNotesLink = {
    typographyProps: { size: 12 },
    css: css`
        margin-top: 11px;
        span {
            font-size: ${TYPOGRAPHY.size.smaller} !important;
        }
    `,
};
productListLineStyles.selectedCheckbox = {
    sizeVariant: "default",
    css: css`
        @media print {
            display: none;
        }
        margin-right: 10px;
    `,
};

productListLineStyles.deleteLink = {
    typographyProps: { size: 12 },
    css: css`
        span {
            font-size: ${TYPOGRAPHY.size.smaller} !important;
        }
    `,
};

productListLineStyles.addToCartButton = mergeToNew(productListLineStyles.addToCartButton, {
    css: css`
        &:hover {
            background: ${getColor("text.accent")};
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
});
